import { Component, EventEmitter, Input, Output } from '@angular/core';

export type PagerPage = number | '...';

@Component({
  selector: 'payarc-pager',
  template: `
    <nav class="pa-pager" aria-label="Pagination">
      <span class="pa-pager__info" *ngIf="rangeLabel">{{ rangeLabel }}</span>
      <div class="pa-pager__controls">
        <button type="button" class="pa-pager__btn" [disabled]="disablePrev" (click)="prev.emit()" aria-label="Previous page">Previous</button>
        <button type="button" class="pa-pager__btn" *ngFor="let p of pages"
          [class.pa-pager__btn--active]="p === currentPage"
          [attr.aria-current]="p === currentPage ? 'page' : null"
          [disabled]="p === '...'"
          (click)="selectPage(p)">{{ p }}</button>
        <button type="button" class="pa-pager__btn" [disabled]="disableNext" (click)="next.emit()" aria-label="Next page">Next</button>
      </div>
    </nav>`,
  styleUrls: ['./payarc-pager.component.css'],
  standalone: false
})
export class PayarcPagerComponent {
  @Input() rangeLabel?: string;
  @Input() pages: PagerPage[] = [];
  @Input() currentPage?: number;
  @Input() disablePrev = false;
  @Input() disableNext = false;
  @Output() prev = new EventEmitter<void>();
  @Output() next = new EventEmitter<void>();
  @Output() pageSelect = new EventEmitter<number>();

  selectPage(p: PagerPage) {
    if (typeof p === 'number') {
      this.pageSelect.emit(p);
    }
  }
}
